import { Link } from "react-router-dom";
import { categoryMetaMap, getItemsByType } from "@/utils/catalog";
import type { CatalogType } from "@/types/catalog";

const entries: { type: CatalogType; icon: string; gradient: string }[] = [
  { type: "movie", icon: "ri-film-line", gradient: "from-primary-500 to-primary-700" },
  { type: "tv", icon: "ri-tv-2-line", gradient: "from-accent-500 to-accent-700" },
  { type: "variety", icon: "ri-movie-2-line", gradient: "from-secondary-500 to-secondary-700" },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 leading-tight">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-500">按类型快速浏览你感兴趣的影视内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        {entries.map((entry) => {
          const meta = categoryMetaMap[entry.type];
          const count = getItemsByType(entry.type).length;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 hover:-translate-y-1 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 rounded-lg bg-gradient-to-br ${entry.gradient} flex items-center justify-center text-background-50 text-2xl mb-4`}
              >
                <i className={entry.icon}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-1">{meta.channel}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                {meta.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">共 {count} 部内容</span>
                <span className="flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                  进入频道
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}